import { Directive, HostListener, Input } from '@angular/core';
import { TrackingService } from '../services/tracking.service';

@Directive({
  selector: '[trackingEvent]',
  standalone: false,
})
export class TrackingEventDirective {
  @Input() trackingEvent: string;
  @Input() trackingData: any;

  constructor(private trackingService: TrackingService) {}

  @HostListener('click') onClick() {
    this.trackingService.trackEvent(this.trackingEvent, null, this.trackingData);
  }
}
